import Create from './Create'

export default Create